import React, { useState } from "react";
import HeroSection from "./heroSection";
import InfoSection from "./infoSection";
import BlogPost from "./blogPosts";
import  Navbar  from "./../../components/navbar";
import { Sidebar } from "./sidebar";

import Image1 from "./../../images/logobackgroundBlank.png";
import Image3 from "./../../images/Wheretostart.svg";
import InfoSectionLight from "./infoSectionLight";
import Services from "./services";

export const HomePage = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <Sidebar isOpen={isOpen} toggle={toggle} />
      <Navbar toggle={toggle} />
      <HeroSection />
      <InfoSection
        image={Image1}
        id="about"
        subtitle=" "
        title="About NCFI-Guard:"
        text="NCFI-Guard is proudly part of the NCFI group with a specific focus on cyber security services. 
        Our mission is to ensure the continued security of our clients by recognising the challenges they face and building leading solutions to mitigate those risks. With a focus on innovation, collaboration, and client satisfaction, we are committed to delivering world-class security solutions that enable our clients to operate with confidence and peace of mind."
        btnText="Contact Us"
      />
      <Services />
      <InfoSectionLight
        image={Image3}
        id="#"
        subtitle=" "
        title="Unsure Where To Start ?"
        text="Ever felt like you should be doing more in terms of cyber security but not sure where to start and feel that ''Industry Leaders'' are not exactly 'leading'.......         We built a no-nonsense guide to security that's linked to realistic solutions, services and support which can help beginners to seasons professionals"
        btnText="Find Out More"
      />
<BlogPost/>

    </>
  );
};

export default  HomePage;
